<template>
  <div v-if="planningOrder">
    <form-wizard
      ref="refFormWizard"
      color="#00cfe8"
      :title="null"
      :subtitle="null"
      finish-button-text="Submit"
      back-button-text="Previous"
      hide-buttons
      class="checkout-form-wizard steps-transparent"
    >

      <!-- address -->
      <tab-content
        title="Dirección / Entrega"
        icon="feather icon-home"
      >
        <e-commerce-checkout-step-address
          :payment-details="checkoutDetails.payment"
          :address-details="checkoutDetails.address"
          @next-step="formWizardNextStep"
        />
      </tab-content>

      <!-- social link -->
      <tab-content
        title="Pago"
        icon="feather icon-credit-card"
      >
        <e-commerce-checkout-step-payment
          :payment-details="checkoutDetails.payment"
          :address-details="checkoutDetails.address"
          @next-step="formWizardNextStep"
        />
      </tab-content>
    </form-wizard>
  </div>
  <loading-skeleton v-else />
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import { ref } from '@vue/composition-api'
import api from '@/plugin/axios'
import LoadingSkeleton from '@/views/misc/LoadingSkeleton.vue'
import ECommerceCheckoutStepPayment from './ECommerceCheckoutStepPayment.vue'
import ECommerceCheckoutStepAddress from './ECommerceCheckoutStepAddress.vue'

export default {
  components: {
    LoadingSkeleton,
    // 3rd Party
    FormWizard,
    TabContent,

    // SFC
    ECommerceCheckoutStepAddress,
    ECommerceCheckoutStepPayment,
  },
  data() {
    return {
      planningOrder: null,
      fabrication: null,
    }
  },
  setup() {
    const refFormWizard = ref(null)
    const formWizardNextStep = () => {
      refFormWizard.value.nextTab()
    }

    // ? This is just dummy details
    const checkoutDetails = ref({
      address: {
        full_name: '',
        phone: '',
        address: '',
        landmark: '',
        city: '',
        state: '',
        addressType: null,
      },
      payment: {
        items: [],
        shipping_cost: 0,
      },
    })

    return {
      refFormWizard,
      formWizardNextStep,

      // Dummy Details
      checkoutDetails,
    }
  },
  async created() {
    const [response] = await Promise.all([
      api.get(`/api/planning-orders/${this.$route.params.id}`),
    ])

    this.planningOrder = response.data
    this.checkoutDetails.address.clinic_name = this.planningOrder.order.clinic.user.full_name
    this.checkoutDetails.address.clinic_phone = this.planningOrder.order.clinic.user.phone
    this.checkoutDetails.address.clinic_whatsapp = this.planningOrder.order.clinic.whatsapp
    this.checkoutDetails.address.address = this.planningOrder.order.clinic.address
    this.checkoutDetails.address.city = this.planningOrder.order.clinic.city.name
    this.checkoutDetails.address.department = this.planningOrder.order.clinic.department.name
    this.checkoutDetails.address.dentist_full_name = this.planningOrder.order.dentist.full_name
    this.checkoutDetails.address.dentist_phone = this.planningOrder.order.dentist.phone
    this.checkoutDetails.address.dentist_email = this.planningOrder.order.dentist.email

    if (this.$route.params.payment_type === 'planificacion') {
      this.checkoutDetails.payment.total_cost = this.planningOrder.total_cost
      this.checkoutDetails.payment.items.push({
        text: 'Planificación',
        planning_cost: this.planningOrder.planning_cost,
      })
    } else if (this.$route.params.fabrication) {
      const [fabrication] = await Promise.all([
        api.get(`/api/aligner-fabrications/${this.$route.params.fabrication}`),
      ])

      console.log('fabrication', fabrication)

      this.fabrication = fabrication.data

      this.checkoutDetails.payment.total_cost = this.fabrication.calculate_cost.total_cost
      this.checkoutDetails.payment.shipping_cost = this.fabrication.calculate_cost.shipping_cost
      this.checkoutDetails.payment.items.push({
        text: 'Alineadores superiores',
        planning_cost: this.fabrication.calculate_cost.price_per_aligner * this.fabrication.calculate_cost.upper_aligners,
      })
      this.checkoutDetails.payment.items.push({
        text: 'Alineadores inferiores',
        planning_cost: this.fabrication.calculate_cost.price_per_aligner * this.fabrication.calculate_cost.lower_aligners,
      })
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-wizard.scss';
@import '~@core/scss/base/pages/app-ecommerce.scss';
@import '~vue-form-wizard/dist/vue-form-wizard.min.css';
</style>

<style lang="scss" scoped>
.checkout-form-wizard ::v-deep {
  .wizard-tab-content {
    box-shadow: none !important;
    background: transparent !important;
    padding: 0;
  }
}
</style>
